import {rootState} from '@mintdata-wsp/common/state/RootState';
import {action} from 'mobx';

export class AnyPageController
{
    @action.bound
    public disablePageLoader():void
    {
        rootState.ui.anyPage.isLoading = false;

        const loader = document.getElementById('page-loader');

        if( !loader ) return;

        loader.classList.add('page-loader-remove');

        setTimeout(() =>
        {
            loader.remove();
        }, 1100);
    }
}
